module.exports = __webpack_public_path__ + "img/wash1.788b6eb9.png";